import React, { useState } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { emailValidator } from '../../common/sharedFunctions';
import { phoneValidator } from '../PhoneFieldFormatter/PhoneFieldFormatter';
import { EmailPhoneInput } from '../EmailPhoneInput/EmailPhoneInput';

export const Search = ({ handleSearch }) => {
  const [emailInput, setEmailInput] = useState('');
  const [phoneInput, setPhoneInput] = useState('');

  const handleSearchClick = () => {
    const email = emailValidator(emailInput) ? emailInput : undefined;
    const phone = phoneValidator(phoneInput) ? phoneInput : undefined;
    handleSearch(email, phone);
  };

  return (
    <div className="sui-grid sui-gap-4">
      <EmailPhoneInput
        name="search"
        emailCallback={setEmailInput}
        emailValue={emailInput}
        phoneCallback={setPhoneInput}
        phoneValue={phoneInput}
      />
      <div className="sui-grid sui-grid-cols-8">
        <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
        <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3">
          <Button fullWidth data-testid="searchButton" onClick={handleSearchClick}>Search</Button>
        </div>
      </div>
    </div>
  );
};

Search.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};
